export { FractalSdkCommonChain } from '@fractalwagmi/fractal-sdk-public-api';
//# sourceMappingURL=common.js.map